import React from "react";
import { useParams, useOutletContext } from "react-router-dom";
import { BrandingPanel } from "../components/branding-panel";
import type { AdminOutletContext } from "../lib/outlet-context";

export function ClientBrandingPage() {
  const { clientId } = useParams();
  const { clients, api } = useOutletContext<AdminOutletContext>();
  const client = clients.find((c) => c.id === clientId);

  if (!client) {
    return (
      <div className="flex flex-col items-center justify-center rounded-lg border border-dashed py-16 text-center">
        <p className="text-sm text-muted-foreground">Client not found</p>
        <p className="mt-1 text-xs text-muted-foreground">It may still be loading — try refreshing.</p>
      </div>
    );
  }

  return (
    <div>
      {client.d1_database_id ? (
        <BrandingPanel client={client} api={api} />
      ) : (
        <div className="flex flex-col items-center justify-center rounded-lg border border-dashed py-16 text-center">
          <p className="text-sm text-muted-foreground">Site not provisioned yet</p>
          <p className="mt-1 text-xs text-muted-foreground">
            Provision this client's site before editing its branding.
          </p>
        </div>
      )}
    </div>
  );
}
